import './accordion.scss';

/**
// we handle all "normal" accordion js action via global app.js data-for-checkbox function
// so if you have to edit something first take a look at that.
// this js only handled the close all other accordions expect for that what you currently have clicked
// this js is only for the only one active checkbox
 */

class Accordion {
    constructor (element, options) {
        this.$accordionElement = element;
        this.$parent = this.$accordionElement.parentElement;
        this.$checkbox = this.$parent.querySelector('input[type="checkbox"]');
        this.$trigger = this.$parent.querySelector('[data-for-checkbox]');
        this.$accordionRoot = this.$parent.parentElement;

        const settings = {
            onlyOneActive: true
        };

        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        if (this.settings.onlyOneActive) {
            this.setEvents();
        }
    }

    setEvents () {
        if (this.$checkbox && this.$trigger) {
            this.$trigger.addEventListener('click', (e) => {
                this.getAllOtherCheckboxesInAccordion(e.target.dataset.forCheckbox);
            });
        }
    }

    getAllOtherCheckboxesInAccordion (currentId) {
        const $$accordionCheckboxes = this.$accordionRoot.querySelectorAll('input[type="checkbox"]');
        const $$accordionTrigger = this.$accordionRoot.querySelectorAll('[data-for-checkbox]');

        if ($$accordionCheckboxes.length > 0) {
            $$accordionCheckboxes.forEach($accordionCheckbox => {
                if (currentId !== $accordionCheckbox.id) {
                    $accordionCheckbox.checked = false;
                }
            });
        }

        if ($$accordionTrigger.length > 0) {
            $$accordionTrigger.forEach($accordionTrigger => {
                if (currentId !== $accordionTrigger.dataset.forCheckbox) {
                    $accordionTrigger.setAttribute('aria-selected', 'false');
                }
            });
        }
    }
}

export { Accordion };

if (!window.accordionLoaded) {
    window.addEventListener('content.loaded', (e) => {
        const eventDetails = e.detail;
        const $context = eventDetails.$context;

        const $accordionElements = $context.querySelectorAll('[data-accordion="item"]');

        if ($accordionElements.length > 0) {
            const $root = $accordionElements[0].closest('.accordion');

            for (let i = 0; i < $accordionElements.length; i++) {
                const $accordionElement = new Accordion($accordionElements[i], {
                    onlyOneActive: $root.getAttribute('data-accordion-one-active') === '1'
                });
                $accordionElement.initialize();
            }
        }
    });
}
